import { lazy } from 'solid-js'
import { messages } from '../../pages/listing-photos-page/listing-photos-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/listing-photos-page/listing-photos-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/listing/:listing_id/photos',
    showFooter: true,
    showHeaderMenu: false,
    showUserHeader: true,
    titleMessage: messages.titleMessage,
}
